// extracted by mini-css-extract-plugin
export var animate = "Modal-module--animate--cc0a6";
export var backdrop = "Modal-module--backdrop--607c2";
export var close = "Modal-module--close--f2e08";
export var modal = "Modal-module--modal--2c201";